// src/concernReport/index.js  →  dist/concernReport.js
//
// Staff "Report a concern" modal (whistleblowing #9, staff-facing side).
// Extracted VERBATIM from index.html's inline script (frontend breakup wave 3).
// This is the STAFF submit surface (POST /api/concern, tokenless/anonymous) —
// distinct from the HO-only review viewer in src/concerns/ (dist/concerns.js,
// loaded by admin.html). Window-binds openConcern/closeConcern/submitConcern so
// the bare onclick="" call sites in index.html keep resolving.
//
// Free variables (DB, fetch, document, window, setTimeout) live in the inline
// globals scope of index.html; esbuild leaves them as bare references at runtime.

(function () {
  function $(id) { return document.getElementById(id); }
  window.openConcern = function () { var o = $('concernOverlay'); if (o) { o.style.display = 'block'; document.body.style.overflow = 'hidden'; } };
  window.closeConcern = function () { var o = $('concernOverlay'); if (o) { o.style.display = 'none'; document.body.style.overflow = ''; } };
  window.submitConcern = async function () {
    var detail = (($('concernDetail') || {}).value || '').trim();
    var status = $('concernStatus');
    if (!detail) { if (status) { status.style.color = 'var(--danger)'; status.textContent = 'Please describe your concern.'; } return; }
    var btn = $('concernSubmitBtn'); if (btn) btn.disabled = true;
    if (status) { status.style.color = 'var(--sub)'; status.textContent = 'Sending…'; }
    try {
      var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
      var res = await fetch(base + '/api/concern', { cache: 'no-store',
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          detail: detail,
          category: ($('concernCategory') || {}).value || null,
          reporter_name: (($('concernName') || {}).value || '').trim() || null,
          reporter_contact: (($('concernContact') || {}).value || '').trim() || null,
          store: (($('concernStore') || {}).value || '').trim() || null
        })
      });
      if (!res.ok) throw new Error('status ' + res.status);
      if (status) { status.style.color = 'var(--ok)'; status.textContent = 'Thank you. Your concern has been sent to Head Office, confidentially.'; }
      ['concernDetail', 'concernName', 'concernContact', 'concernStore', 'concernCategory'].forEach(function (id) { var el = $(id); if (el) el.value = ''; });
      setTimeout(window.closeConcern, 2800);
    } catch (e) {
      if (status) { status.style.color = 'var(--danger)'; status.textContent = 'Could not send right now. Please try again, or tell Head Office directly.'; }
    } finally { if (btn) btn.disabled = false; }
  };
})();
